export const HOMEPAGE = "/anasayfa"
export const LOGIN = "/login"
export const InfoComponent = "/info"
export const REGISTER = "/register"
export const NOT_AUTHORIZED = '/not-authorized'
export const FORGOT_PASSWORD = '/forgot-password'
